export default class Form {
    constructor($form) {
        this.$form = $form;
        this.$inputs = this.$form.querySelectorAll('[data-input]');

        this.animateLabelFocus = this.animateLabelFocus.bind(this);
        this.animateLabelBlur = this.animateLabelBlur.bind(this);

        this.$inputs.forEach($trigger => $trigger.addEventListener('focus', this.animateLabelFocus));
        this.$inputs.forEach($trigger => $trigger.addEventListener('blur', this.animateLabelBlur));
    }

    animateLabelFocus(e) {
        e.target.parentNode.classList.add('focused');
    }

    animateLabelBlur(e) {
        var inputValue = e.target.value;
        if ( inputValue === "" ) {
            e.target.parentNode.classList.remove('focused');
        }
    }
}